<template>
    <div v-if="orderServiceEmpty">
        <q-inner-loading :showing="orderServiceEmpty">
            <q-spinner-pie color="primary" size="40px" />
        </q-inner-loading>
    </div>
    <div v-else class="order-item row">
        <!-- service image -->
        <div
            class="course-img"
            :style="`background-image: url(${require('@/assets/logo.png')})`"
        >
            <div class="overlay" :class="overlayColor(index)"></div>
        </div>
        <!-- service info: type and description -->
        <div class="course-info col-12 col-sm-grow col-md-4 col-lg-6">
            <div class="course-type row items-center">
                <q-icon name="design_services" class="q-mr-sm"></q-icon>
                {{ $t('general.services') }}
            </div>
            <h5>
                {{ orderService.description }}
            </h5>
        </div>

        <!-- prices and units -->
        <div class="course-price col-12 col-sm-12 col-md text-right">
            <div class="row justify-end q-mt-sm">
                <div class="course-quantity col-auto">
                    <span class="q-mx-md q-my-sm">{{
                        orderService.quantity
                    }}</span>
                    <span>UN</span>

                    <div class="text-caption">
                        <span class="text-uppercase"
                            >{{ $t('cart.unit_price_abbreviation') }} ({{
                                $t('general.without_vat')
                            }})</span
                        >:
                        <!-- normal price -->
                        <span
                            :class="[
                                {
                                    'text-strike':
                                        orderService.promotion_discount,
                                },
                                {
                                    'text-body1': !orderService.promotion_discount,
                                },
                            ]"
                            >{{
                                new Intl.NumberFormat(
                                    currency.definition['locale'],
                                    {
                                        style: 'currency',
                                        currency: currency.key,
                                    }
                                ).format(
                                    parseFloat(
                                        JSON.parse(orderService.unit_price)[
                                            currency.key
                                        ]
                                    )
                                )
                            }}</span
                        >
                    </div>
                </div>
                <div class="price">
                    <span>
                        ({{ orderService.tax
                        }}{{ $t('general.vat_percentage') }})
                    </span>
                    {{
                        new Intl.NumberFormat(currency.definition['locale'], {
                            style: 'currency',
                            currency: currency.key,
                        }).format(
                            JSON.parse(orderService.item_total)[currency.key]
                        )
                    }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import store from '@/store'
import { slugs } from '@/local-shared/mixins/slugs'
import env from '@/.env.js'
import _ from 'lodash'

export default {
    name: 'OrderServiceComponent',

    mixins: [translate],

    props: {
        index: {
            type: Number,
            default: 0,
        },

        orderService: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            quantity: this.orderService.quantity,

            slugs: slugs,
        }
    },

    computed: {
        orderServiceEmpty() {
            return _.isEmpty(this.orderService)
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },
    },

    methods: {
        overlayColor(index) {
            return 'overlay-color-' + (index % 3)
        },

        getImage(pictureId) {
            return `${env.endpoint_backend}/pictures/${pictureId}`
        },
    },
}
</script>
